@if (items !== undefined) {
    <ng-container class="overview-table">
        <osc-base-table
            [items]="items | async"
            [columns]="columns"
            [hideMarkedBar]="hideMarkedBar"
            [showCheckboxColumn]="showCheckboxColumn"
            (rowSelect)="onRowSelect($event)"
            class="gearoil-overview-table"
        >
            <ng-container cdkColumnDef="itemNumber">
                <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                    <osc-text-filter-table-header
                        [name]="'GEAROIL.OVERVIEW.DIALOG.TABLEHEADER.ITEMNUMBER' | translate"
                        [filterProperty]="'itemNumber'"
                        [tagPosition]="0"
                        [hideSortIconOnClosedState]="true"
                        [ellipsis]="true"
                        sortOrder="ascending"
                        class="header"
                    ></osc-text-filter-table-header>
                </th>
                <td cdk-cell *cdkCellDef="let row">{{ row.rowData.itemNumber }}</td>
            </ng-container>
            <ng-container cdkColumnDef="lubricantType">
                <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                    <osc-selection-filter-table-header
                        [name]="'GEAROIL.OVERVIEW.DIALOG.TABLEHEADER.LUBRICANTTYPE' | translate"
                        [filterProperty]="'lubricantType'"
                        [filterValues]="lubricantTypeFilterValues"
                        [tagPosition]="2"
                        sortOrder="ascending"
                        [ellipsis]="true"
                        [filterType]="filterTypes.TEXT_EQUAL_FILTER"
                        [hasReset]="true"
                        class="header"
                    >
                    </osc-selection-filter-table-header>
                </th>
                <td cdk-cell *cdkCellDef="let row">{{ row.rowData.lubricantType }}</td>
            </ng-container>
            <ng-container cdkColumnDef="characteristics">
                <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                    <osc-selection-filter-table-header
                        [name]="'GEAROIL.OVERVIEW.DIALOG.TABLEHEADER.CHARACTERISTICS' | translate"
                        [filterProperty]="'formattedCharacteristics'"
                        [filterValues]="characteristicsFilterValues"
                        [tagPosition]="3"
                        sortOrder="ascending"
                        [ellipsis]="true"
                        [filterType]="filterTypes.TEXT_FILTER"
                        [hasReset]="true"
                        class="header"
                    >
                    </osc-selection-filter-table-header>
                </th>
                <td cdk-cell *cdkCellDef="let row">{{ row.rowData.formattedCharacteristics }}</td>
            </ng-container>
            <ng-container cdkColumnDef="viscosity">
                <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                    <osc-selection-filter-table-header
                        [name]="'GEAROIL.OVERVIEW.DIALOG.TABLEHEADER.VISCOSITY' | translate"
                        [filterProperty]="'viscosity'"
                        [filterValues]="viscosityFilterValues"
                        [tagPosition]="3"
                        sortOrder="ascending"
                        [ellipsis]="true"
                        [filterType]="filterTypes.TEXT_EQUAL_FILTER"
                        [hasReset]="true"
                        class="header"
                    >
                    </osc-selection-filter-table-header>
                </th>
                <td cdk-cell *cdkCellDef="let row">{{ row.rowData.viscosity }}</td>
            </ng-container>
            <ng-container cdkColumnDef="size">
                <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                    <osc-selection-filter-table-header
                        [name]="'GEAROIL.OVERVIEW.DIALOG.TABLEHEADER.SIZES' | translate"
                        [filterProperty]="'size'"
                        [filterValues]="sizesFilterValues"
                        [tagPosition]="3"
                        sortOrder="ascending"
                        [ellipsis]="true"
                        [filterType]="filterTypes.TEXT_EQUAL_FILTER"
                        [hasReset]="true"
                        class="header"
                    >
                    </osc-selection-filter-table-header>
                </th>
                <td cdk-cell *cdkCellDef="let row">{{ row.rowData.size }}</td>
            </ng-container>
            <ng-container cdkColumnDef="approvedGearbox">
                <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                    <osc-selection-filter-table-header
                        [name]="'GEAROIL.OVERVIEW.DIALOG.TABLEHEADER.GEARBOXES' | translate"
                        [filterProperty]="'formattedApprovedGearbox'"
                        [filterValues]="gearboxFilterValues"
                        [tagPosition]="3"
                        sortOrder="ascending"
                        [ellipsis]="true"
                        [filterType]="filterTypes.TEXT_FILTER"
                        [hasReset]="true"
                        class="header"
                    >
                    </osc-selection-filter-table-header>
                </th>
                <td cdk-cell *cdkCellDef="let row">
                    {{ row.rowData.formattedApprovedGearbox }}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="expandableRow"> </ng-container>
            <ng-container cdkColumnDef="fullRowContent"> </ng-container>
            <ng-container cdkColumnDef="groupHeaderIcon"> </ng-container>
            <ng-container cdkColumnDef="groupHeaderName"> </ng-container>
        </osc-base-table>
    </ng-container>
}
